/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-08-06 14:03:32
 **/

import { Maybe } from "@/frameworks/libraries/components";

import { usePhoneCall } from "@/frameworks/core/hooks";
import Tabs from "../Tabs";
import GroupCallHistoryTab from "../Tabs/GroupCallHistoryTab";
import GroupCallTabInfo from "../GroupCallTabInfo";

export default function CallHistoryTabs(props: PushServices.Call.PhoneDetailProps) {
	const { callID } = props;
	const phoneCall = usePhoneCall();
	const callees = phoneCall.state.callees[0];
	const detailInfo = phoneCall.state.phone_detail[0];
	const isGroupCallHistory = detailInfo.tabID === "group-call-history";
	const { myCallJoinState } = phoneCall.state.active;

	return (
		callees.length > 0 && (
			<Maybe
				test={
					(!isGroupCallHistory && callees.length > 1) ||
					(isGroupCallHistory && myCallJoinState?.status === "REQUESTED")
				}
				fallback={
					<>
						<Maybe test={isGroupCallHistory && callees.length > 1} fallback={<Tabs {...props} />}>
							<GroupCallHistoryTab callID={callID} />
						</Maybe>
					</>
				}
			>
				<GroupCallTabInfo callID={callID} />
			</Maybe>
		)
	);
}
